/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { StartUp, SignInSignUp, Login, GDPR } from 'ui/pages';
import { Selectors } from 'store/ducks/startUp';
import { StartUpRoutePath } from './paths';
import AnimatedRoute from './AnimatedRoute';

type StartRouteProps = RouteProps &
  React.Attributes & {
    path: StartUpRoutePath;
    children: JSX.Element;
  };

function StartDependentRoute({ path, children, key, exact = false }: StartRouteProps): JSX.Element {
  const startUpStatus = useSelector(
    Selectors.status,
    () => true // ignore store updates
  );

  return (
    <AnimatedRoute
      path={path}
      key={key}
      exact={exact}
      render={() => {
        return startUpStatus ? children : <Redirect to={StartUpRoutePath.ROOT} />;
      }}
    />
  );
}

export default function StartUpRoutes(): JSX.Element[] {
  return [
    <Route path={StartUpRoutePath.ROOT} key={StartUpRoutePath.ROOT} exact>
      <StartUp />
    </Route>,
    <StartDependentRoute path={StartUpRoutePath.SIGNIN_SINGNUP} key={StartUpRoutePath.SIGNIN_SINGNUP} exact>
      <SignInSignUp />
    </StartDependentRoute>,
    <StartDependentRoute path={StartUpRoutePath.CODE} key={StartUpRoutePath.CODE} exact>
      <Login withCode />
    </StartDependentRoute>,
    <StartDependentRoute path={StartUpRoutePath.SIGNIN} key={StartUpRoutePath.SIGNIN} exact>
      <Login />
    </StartDependentRoute>,
    <StartDependentRoute path={StartUpRoutePath.GDPR} key={StartUpRoutePath.GDPR} exact>
      <GDPR />
    </StartDependentRoute>,
  ];
}
